import { render } from "./ScrollButton.vue?vue&type=template&id=7c5c5019"
import script from "./ScrollButton.vue?vue&type=script&lang=js"
export * from "./ScrollButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__